import { Directive, Input, ElementRef, Renderer2, OnChanges, RendererStyleFlags2 } from '@angular/core'
import { IAtividadeComponenteDAL } from '@medlogic/shared/shared-interfaces';

@Directive({
  selector: '[libCtrlGridColumn]'
})
export class CtrlGridColumnDirective implements OnChanges {

  private _ctrl: IAtividadeComponenteDAL;
  @Input() isMobile: boolean;
  @Input('libCtrlGridColumn') public get ctrl(): IAtividadeComponenteDAL {
    return this._ctrl;
  }

  public set ctrl(v: IAtividadeComponenteDAL) {
    this._ctrl = v;
  }

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  // Para resolver o problema do - na atualização, procurar um evento que não seja o Init
  ngOnChanges(): void {
    this.applyStyles(this.ctrl);
  }

  applyStyles(ctrl: IAtividadeComponenteDAL): void {
    if (ctrl && !this.isMobile) {
      // garante que o container do elemento respeite o modelo de grid
      this.renderer.setStyle(this.el.nativeElement, 'display', 'block', RendererStyleFlags2.Important);
      this.renderer.setStyle(this.el.nativeElement, 'box-sizing', 'border-box');

      // largura mínima de uma coluna
      this.renderer.setStyle(this.el.nativeElement, 'min-width', `${ctrl.ColumnWidth}px`);
      this.renderer.setStyle(this.el.nativeElement, 'max-width', `${ctrl.ColumnWidth}px`);

      // faz o item ocupar N colunas
      this.renderer.setStyle(this.el.nativeElement, 'grid-column', `span 1`);
    }
  }
}
